<template>
    <vMaterialSourceComponent :postList="postList" v-if="flag"></vMaterialSourceComponent>
</template>
<script>
import vMaterialSourceComponent from '../../listComponent/basicdata/materialSource/materialSourceComponent.vue';
export default {
    name: 'materialSource',
    components: {
        vMaterialSourceComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                code: true,
                quality_assurance_code: true,
                edition_code: true,
                quality_standard: true,
                material_rid: true,
                manufacturer_rid: true,
                material_rid: true,
            },
            flag: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>